//Library Imports
import { useDrop } from "react-dnd";
import styled from "styled-components";
import { useSelector } from "react-redux";
import store from "store";

//Local Imports
import { ReactComponent as Drop } from "../../../assets/img/icons/nav/Drop.svg";
import { ItemTypes } from "./ItemTypes";
import { createNewEmail } from "../../EmailBrowser/actions";
import { removeSelectedIds, setCheckArticles, setHoveredAssetId } from "../../Content/DragnDrop/actions";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";

const CreateNewEmailButton = () => {
  const hoveredAssetId = useSelector((state) => state.dragDrop.hoveredAssetId);
  const isDragging = useSelector((state) => state.dragDrop.isDragging);

  const [{ isOver, isDropped }, drop] = useDrop(() => ({
    // The type (or types) to accept-strings or symbols
    accept: ItemTypes.BOX,
    // called when an item is dropped.
    drop(item, monitor) {
      setCheckArticles(!store.getState().dragDrop.droppedArticles);
      const selectedArticles = store.getState().dragDrop.selectedIds;
      const draggedItem = store.getState().dragDrop.draggedItem;
      //* call action to create new mail without campaign
      let campaignId = getQueryCampaignId();
      setHoveredAssetId(0);
      createNewEmail(
        selectedArticles.length > 0 ? selectedArticles.toString() : draggedItem?.id.toString(),
        campaignId,
        campaignId > 0
      );
      removeSelectedIds();
    },
    // Props to collect
    collect: (monitor) => ({
      // isDragging: monitor.isDragging(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      isDropped: monitor.didDrop(),
    }),
  }));

  //: TODO: write a function to handle the drop on Create New Email Button

  if (isDragging && isOver) {
    setTimeout(() => {
      setHoveredAssetId(1);
    }, 1);
  }

  if ((isDragging || isDropped) && !isOver && hoveredAssetId === 1) {
    setHoveredAssetId(0);
  }

  // let onBoarding = contentExplorer === 1 && contentExplorerStep === 6;
  let onBoarding = false;

  return (
    <div ref={drop} style={{ marginRight: "10px" }}>
      <Wrapper
        hover={isOver}
        // onBoarding={onBoarding}
        className={`${(hoveredAssetId !== 0 && hoveredAssetId !== 1) || !isDragging ? "disabled-item" : ""} ${
          onBoarding ? "drop-box" : ""
        }`}
        id="createNewEmailDropbox"
      >
        <Drop />
        {"Drop articles here to create a new email…"}
        {/* {!onBoarding ? "Drop articles here to create a new email…" : "Create New Emails..."} */}
      </Wrapper>
    </div>
  );
};

const Wrapper = styled.div`
  background-color: ${(props) => (props.hover ? "#27CE0A" : "#fff")};
  color: ${(props) => (props.hover ? "#fff" : "RGBA(66, 75, 80, 0.8)")};
  margin-right: 10px;

  #plus-id {
    fill: ${(props) => (props.hover ? "#fff" : "#27CE0A")};
  }
  svg {
    margin-right: 20px;
    fill: #fff;
    min-width: 45px;
    height: auto;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      /* width: 12px; */
      min-width: 30px;
      margin-right: 10px;
    }
  }
  ${(props) =>
    props.onBoarding
      ? `
    background-color : rgba(39, 206, 10, 0.1);
    border: 0;
    color: rgb(39, 206, 10);
    font-family: "Roboto";
    font-weight: 500;
    font-size: 20px;
    padding: 10px 10px !important;
    border-radius: 10px;
    letter-spacing: -0.5px;
    margin-bottom: 50px;
    
    @media all and(max-width: 1439px) {
      font-size: 14px;
      border-radius: 7px;
    }
    img {
      padding-right: 10px;
      margin-top: -3px;
      width: 22px;
      
    }`
      : ""}
  ${(props) =>
    props.hover
      ? `
      animation: blink 0.5s 3; 
      background-color: #27CE0A;
      border: solid 1px #27CE0A;
      color: #fff;
      #plus-id {
        fill: #fff;
      }
  `
      : ""}

  .add-icon {
    margin-right: 15px;
  }
  &.disabled-item {
    opacity: 0.3;
    pointer-events: none;
  }
  cursor: pointer;
  border: dotted 2px #27ce0a;
  /* stroke-dasharray: 6px;
  gap: 6px;
  stroke-width: 6px;
  stroke-linecap: round;
  stroke-linejoin: miter; 
  padding-left: 1em;
  padding-right: 1.5em;*/
  border-radius: 10px;
  height: 114px;
  padding: 29px 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  font-size: 26px;
  line-height: 30px;
  font-family: "Roboto Slab", serif;
  font-weight: 600;
  background: linear-gradient(180deg, rgba(39, 206, 10, 0.31) 0%, rgba(39, 206, 10, 0.07) 100%);
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 16px;
    line-height: 20px;
    height: 54px;
    border-radius: 7px;
  }
`;
export default CreateNewEmailButton;
